<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row v-if="!loadingData">
      <v-col cols="11" class="mx-auto pb-0">
        <p
          :class="
            mobile()
              ? 'text-h5 font-weight-bold ml-16 mr-16'
              : 'text-h5 font-weight-bold'
          "
          :align="mobile() ? 'center' : 'left'"
        >
          {{ $t("subscriptionTitle") }}
        </p>
      </v-col>
    </v-row>
    <v-row class="mx-auto" v-if="!loadingData && productPlan.attributes">
      <v-col
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto px-0'"
      >
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="5" xl="4">
            <p class="text-h6 no-break" :align="mobile() ? 'center' : 'left'">
              {{ $t("currentPlan") }}
            </p>

            <v-card
              rounded="xxl"
              class="mb-8 mx-auto"
              data-testid="subscription-current-plan"
            >
              <v-card-text class="pa-5 darktext--text">
                <v-row v-if="productPlan.attributes.name != 'Business+'">
                  <v-col cols="12" class="pt-0">
                    <p
                      class="d-inline-block float-right"
                      v-if="productPlan.attributes.name == 'Pro Trial' || productPlan.attributes.name == 'Free'"
                    >
                      <v-chip
                        v-if="productPlan.attributes.name == 'Pro Trial'"
                        class="d-flex text-small font-weight-bold"
                        label
                        color="anchor20opacity"
                        text-color="accent"
                        >{{
                          $tc("trialDays", trialExpirationDays, {
                            numberDays: trialExpirationDays,
                          })
                        }}
                      </v-chip>
                    </p>
                    <p class="d-inline-block float-right" v-else>
                      <v-chip
                        v-if="productPlan.attributes.name == 'Pro'"
                        class="
                          d-flex
                          text-small text-uppercase
                          font-weight-bold
                        "
                        label
                        color="anchor20opacity"
                        text-color="accent"
                        >{{ $t("popular") }}
                      </v-chip>
                    </p>
                    <p
                      class="text-h5 font-weight-bold d-inline-block mr-3 mb-0"
                      v-if="productPlan.attributes.name != 'Business+'"
                    >
                      {{ productPlan.attributes.name }}
                    </p>
                    <p
                      class="d-inline-block mr-3 mb-0"
                      v-if="productPlan.attributes.name == 'Pro Trial' || productPlan.attributes.name == 'Free'"
                    >
                      <span v-if="productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')" class="text-h6 d-flex error--text"> €0 </span>
                      <span v-else class="text-h6 d-flex accent--text"> €0 </span>
                    </p>
                    
                    <p
                      class="d-inline-block mr-3 mb-0"
                      v-if="
                        productPlan.attributes.name == 'Pro'" >
                      <span
                        class="text-h6 d-flex accent--text text-lowercase"
                        v-if="productPlan.meta && productPlan.meta.plan_properties.pricing.currency == 'eur'"
                      >
                        €{{ productPlan.meta.plan_properties.pricing.amount_due }}
                        </span>
                    </p>
                    
                    <p
                     class="mb-0 mt-n1"
                     v-if="(productPlan.attributes.name == 'Pro') && productPlan.meta && productPlan.meta.plan_properties.status == 'active'"
                    >
                      <span class="text-caption d-flex greytext--text" data-testid="tax">
                       {{ $t("nextPayment") }}
                      </span>
                    </p>
                    <p
                      class="mb-0 mt-n1"
                      v-if="productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')"
                    >
                      <span v-if="productPlan.attributes.name == 'Pro'" class="text-caption d-flex error--text" data-testid="payment-failed">
                        <v-icon x-small class="error--text"
                          >mdi-alert
                        </v-icon> {{ $t("paymentFailed") }}
                      </span>
                      <span v-if="productPlan.attributes.name == 'Free' || productPlan.attributes.name == 'Pro Trial'" class="text-caption d-flex error--text" data-testid="payment-failed">
                        <v-icon x-small class="error--text"
                          >mdi-alert
                        </v-icon> {{ $t("paymentFailed") }}
                      </span>
                    </p>
                    
                  </v-col>
                </v-row>

                <v-row v-if="productPlan.attributes.name != 'Business+'">
                  <v-col
                    cols="12"
                    md="4"
                    align="center"
                  >
                    <span class="d-block text-h5 mb-1">{{
                      productPlan.attributes.boosters 
                    }}</span>
                    <span class="d-block text-body-2 greytext--text">{{
                      $t("downgradeFreePlanBoosters")
                    }}</span>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    align="center"
                  >
                    <span class="d-block text-h5 mb-1">{{
                      productPlan.attributes.space_members
                    }}</span>
                    <span class="d-block text-body-2 greytext--text">{{
                      $t("downgradeFreePlanSpaceMembers")
                    }}</span>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    align="center"
                  >
                    <span class="d-block text-h5 mb-1"
                      >{{
                        productPlan.attributes.storage_gb
                      }}GB</span
                    >
                    <span class="d-block text-body-2 greytext--text">{{
                      $t("downgradeFreePlanStorage")
                    }}</span>
                  </v-col>
                  <v-col
                    cols="12"
                    v-if="productPlan.attributes.scorm_packages == 1"
                    md="4"
                    align="center"
                    data-testid="addon-scorm"
                  >
                    <span class="d-block text-h5 mb-1"
                      ><v-icon large class="darktext--text"
                        >mdi-file-document-outline
                      </v-icon></span
                    >
                    <span class="d-block text-body-2 greytext--text">{{
                      $t("addonScorm")
                    }}</span>
                  </v-col>
                  <v-col
                    cols="12"
                    v-if="productPlan.attributes.workflow_module == 1"
                    md="4"
                    align="center"
                    data-testid="addon-workflow"
                  >
                    <span class="d-block text-h5 mb-1"
                      ><v-icon large class="darktext--text"
                        >mdi-sitemap
                      </v-icon></span
                    >
                    <span class="d-block text-body-2 greytext--text">{{
                      $t("addonWorkflow")
                    }}</span>
                  </v-col>
                </v-row>
                <v-row v-if="productPlan.attributes.name == 'Business+'" data-testid="business-plan">
                  <v-col
                    cols="12"
                    class="pt-0"
                  >
                    <p class="d-inline-block float-right">
                      <v-chip
                        class="
                          d-flex
                          text-small text-uppercase
                          font-weight-bold
                        "
                        label
                        color="anchor20opacity"
                        text-color="accent"
                        >{{ $t("custom") }}
                      </v-chip>
                    </p>
                    <p class="text-h5 font-weight-bold d-inline-block mr-3 mb-0">
                      {{ productPlan.attributes.name }}
                    </p>
                    <p class="d-inline-block mr-3 mb-0"
                    v-if="productPlan.meta &&
                    productPlan.meta.plan_properties.pricing.currency == 'eur'">
                      <span
                        class="text-h6 d-flex accent--text text-lowercase"
                      >
                        €{{ productPlan.meta.plan_properties.pricing.amount_due }}</span>
                    </p>
                    <p
                     class="mb-0 mt-n1"
                     v-if="productPlan.attributes.name == 'Business+' && productPlan.meta && productPlan.meta.plan_properties.status == 'active'"
                    >
                     <span class="text-caption d-flex greytext--text" data-testid="tax">
                       {{ $t("nextPayment") }}
                     </span>
                    </p>
                    <p
                     class="ml-5 mb-0 mt-n1"
                     v-if="productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due')"
                    >
                     <span v-if="productPlan.attributes.name == 'Business+'" class="text-caption d-flex error--text" data-testid="payment-failed">
                      <v-icon x-small class="error--text"
                        >mdi-alert
                      </v-icon> {{ $t("paymentFailed") }}
                     </span>
                   </p>
                   
                    <span class="d-block text-body-2 greytext--text">{{
                      $t("textBusinessPlan")
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="12" align="left" class=" py-0">
                    <v-row :style="mobile() ? '' : 'height:100px'">
                      <v-col cols="12" md="4" align="center">
                        <span class="d-block text-h5 text-uppercase mb-1">SSO</span>
                        <span class="d-block text-body-2 greytext--text">{{
                          $t("businessPlanSSO")
                        }}</span>
                      </v-col>
                      <v-col cols="12" md="4" align="center">
                        <span class="d-block text-h5 mb-1"
                          ><v-icon large class="darktext--text"
                            >mdi-phone-in-talk</v-icon
                          ></span
                        >
                        <span class="d-block text-body-2 greytext--text">{{
                          $t("businessPlanSupport")
                        }}</span>
                      </v-col>
                      <v-col cols="12" md="4" align="center">
                        <span class="d-block text-h5 mb-1"
                          ><v-icon large class="darktext--text"
                            >mdi-monitor-account</v-icon
                          ></span
                        >
                        <span class="d-block text-body-2 greytext--text">{{
                          $t("businessPlanIntegration")
                        }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions
                v-if="productPlan.attributes.name == 'Pro Trial'"
                class="pa-0 justify-center subscription-card-action"
              >
                <span class="text-h6"
                  >{{ $t("subscriptionExpires") }} {{ format_date(trialEnds) }}
                </span>
              </v-card-actions>
               <v-card-actions
                v-else-if="subscriptionEnds"
                class="pa-0 justify-center subscription-card-action"
              >
                <span class="text-h6"
                  >{{ $t("subscriptionExpires") }} {{ format_date(subscriptionEnds) }}
                </span>
              </v-card-actions>
              <v-card-actions
                v-else
                style="height: 70px"
                class="pa-0 justify-center subscription-card-action"
              >
              </v-card-actions>
            </v-card>
            <!--managePlan button-->
            <v-row v-if="productPlan.attributes.name == 'Pro' || productPlan.attributes.name == 'Business+'">
              <v-col cols="12" md="12" class="mt-n2 mx-auto" align="center" data-testid="cancel-subscription">
                    <v-btn
                    data-testid="cancel-link"
                      color="accent"
                      min-width="100"
                      dark
                      elevation="0"
                      class="rounded-xxl text-none px-4 submit"
                      @click="getStripePortal()"
                    >
                      {{ $t("managePlan") }}
                    </v-btn>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                cols="12"
                class="d-flex justify-end pt-0 mt-n5"
                data-testid="delete-subscription"
              >
                <a
                  @click="confirmDeleteSpace"
                  data-testid="link"
                  class="
                    text-body-2
                    grey--text
                    no-break
                    pa-0
                    mr-8
                    text-decoration-underline
                  "
                >
                  {{ $t("subscriptionDelete") }}
                </a>
              </v-col>
            </v-row>
            <!-- Storage plan -->
            <v-row no-gutters>
              <v-col cols="12" md="10">
                <p
                  class="text-h6 no-break py-0"
                  :align="mobile() ? 'center' : 'left'"
                >
                  {{ $t("subscriptionPlanUsage") }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="12"
                class="mx-auto"
                data-testid="subscription-plan-usage"
              >
                <span class="text-body-2 dark--text mb-2">
                  {{ statisticsBoosters }} {{ $tc('usageBooster', statisticsBoosters) }}</span
                >
                <v-row align-content-left justify-left>
                  <v-col
                    cols="8"
                    class="d-flex"
                    align-self="center"
                    justify="center"
                  >
                    <v-progress-linear
                      color="greytext"
                      class="mb-2"
                      rounded
                      :value="
                        Math.ceil((100 * statisticsBoosters) / boosters_allowed)
                      "
                    >
                    </v-progress-linear>
                  </v-col>
                  <v-col
                    cols="4"
                    class="d-flex pt-1"
                    align-self="center"
                    justify="center"
                  >
                    <span class="text-body-2 dark--text"
                      >{{ leftBoosters }} {{ $t("left") }}</span
                    >
                  </v-col>
                </v-row>
                <span class="text-body-2 dark--text mb-2"
                  >{{ statisticsSpaceMembers }} {{ $tc('usageSpaceMembers', statisticsSpaceMembers) }} <br
                /></span>
                <v-row align-content-left justify-left>
                  <v-col
                    cols="8"
                    class="d-flex"
                    align-self="center"
                    justify="center"
                  >
                    <v-progress-linear
                      color="greytext"
                      class="mb-2"
                      rounded
                      :value="
                        Math.ceil(
                          (100 * statisticsSpaceMembers) / leftSpaceMembers
                        )
                      "
                    >
                    </v-progress-linear>
                  </v-col>
                  <v-col
                    cols="4"
                    class="d-flex pt-1"
                    align-self="center"
                    justify="center"
                  >
                    <span class="text-body-2 dark--text">
                      {{ leftSpaceMembers }} {{ $t("left") }}</span
                    >
                  </v-col>
                </v-row>
                <span class="text-body-2 dark--text mb-2">
                  {{ usedStorage }}MB {{ $t("storageUsed") }} <br
                /></span>
                <v-row align-content-left justify-left>
                  <v-col
                    cols="8"
                    class="d-flex"
                    align-self="center"
                    justify="center"
                  >
                    <v-progress-linear
                      color="greytext"
                      class="mb-2"
                      rounded
                      :value="usedStorageProgress"
                    >
                    </v-progress-linear>
                  </v-col>
                  <v-col
                    cols="4"
                    class="d-inline-flex pt-0"
                    align-self="center"
                  >
                    <span
                      class="text-body-2 dark--text pt-2 pr-3"
                      v-if="leftStorage > 0"
                    >
                      {{ leftStorage }} MB {{ $t("left") }}</span
                    >
                    <span class="text-body-2 dark--text pt-2 pr-3" v-else>
                      0.000MB {{ $t("left") }}</span
                    >
                    <v-tooltip bottom data-testid="analytics-icon">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          elevation="0"
                          min-width="36"
                          height="36"
                          class="rounded-xxl text-none px-0 float-right"
                          @click="recalculateStorage"
                          :loading="loadingRecalculate"
                          color="greytext"
                        >
                          <v-icon class="" color="greytext">mdi-reload</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("recalculateTooltip") }}</span>
                    </v-tooltip>
                  </v-col>

                  <v-col
                    cols="12"
                    class="error--text py-0 mt-n3"
                    v-if="productPlan.attributes.name == 'Pro' || productPlan.attributes.name == 'Business+'"
                  >
                    {{ $t("moreStorageWarning") }}
                  </v-col>
                  <v-col cols="12" class="error--text py-0 mt-n3" v-else>
                    {{ $t("moreStorageWarningPro") }}
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                    class="mx-auto"
                    align="center"
                    v-if="productPlan.attributes.name == 'Pro' || productPlan.attributes.name == 'Business+'"
                  >
                    <v-btn
                      color="accent"
                      min-width="100"
                      dark
                      elevation="0"
                      class="rounded-xxl text-none px-4 mt-5 submit"
                      target="_blank"
                      href="https://skillboost.io/contact"
                    >
                      {{ $t("contactUsExtendPlan") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <!--right side cards -->
          <v-col
            cols="12"
            sm="12"
            md="6"
            offset-lg="2"
            lg="5"
            offset-xl="4"
            xl="4"
          > 
            <!--Business plan and pro card right side -->
            <v-row no-gutters v-if="productPlan.attributes.name != 'Business+'"> 
              <v-col cols="12" class="">
                <p
                  class="text-h6 no-break"
                  :align="mobile() ? 'center' : 'left'"
                >
                  {{ $t("subscriptionChangePlan") }}
                </p>
              </v-col>
            </v-row>

            <v-card
              rounded="xxl"
              class="mb-12 mx-auto"
              v-if="productPlan.attributes.name == 'Free' || productPlan.attributes.name == 'Pro Trial'"
              data-testid="upgrade-to-pro-card"
            >
              <v-card-text class="pa-5 darktext--text">
                <v-row>
                  <v-col cols="12" class="pt-0">
                    <p class="d-inline-block float-right">
                      <v-chip
                        class="
                          d-flex
                          text-small text-uppercase
                          font-weight-bold
                        "
                        label
                        color="anchor20opacity"
                        text-color="accent"
                        >{{ $t("popular") }}
                      </v-chip>
                    </p>
                    <p
                      class="text-h5 font-weight-bold d-inline-block mr-3 mb-0"
                    >
                      {{ proName }}
                    </p>
                    <p class="d-inline-block mr-3 mb-0">
                      <span class="text-h6 d-flex accent--text"> €68 </span>
                    </p>
                    <p class="ml-5 my-0">
                      <span class="text-body-2 d-flex ml-8 greytext--text">
                        €78 {{ $t("whenBilledMonthly") }}
                      </span>
                    </p>
                  </v-col>
                </v-row>
                <v-row :style="mobile() ? '' : 'height:100px'">
                  <v-col cols="12" md="4" align="center">
                    <span class="d-block text-h5 mb-1">{{ proBoosters }}</span>
                    <span class="d-block text-body-2 greytext--text">{{
                      $t("downgradeFreePlanBoosters")
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="4" align="center">
                    <span class="d-block text-h5 mb-1">{{
                      proSpaceMembers
                    }}</span>
                    <span class="d-block text-body-2 greytext--text">{{
                      $t("downgradeFreePlanSpaceMembers")
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="4" align="center">
                    <span class="d-block text-h5 mb-1"
                      >{{ proStorage }}GB</span
                    >
                    <span class="d-block text-body-2 greytext--text">{{
                      $t("downgradeFreePlanStorage")
                    }}</span>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions
                class="pa-0 justify-center upgrade-card-action"
                data-testid="upgrade-to-pro-action"
                @click.stop="
                  (upgradeToPlan = 'Pro'),
                    (dialogVisibleUpgradePlan = true),
                    (confirmationDialogTitle = $t(
                      'confirmationDialogTitleUpgradeToPlan' + upgradeToPlan
                    ))
                "
                :style="{ cursor: 'pointer' }"
              >
                <span class="text-h6">{{ $t("upgrade") }}</span>
              </v-card-actions>
            </v-card>

            <v-card rounded="xxl" class="mx-auto" v-if="productPlan.attributes.name != 'Business+'">
              <v-card-text class="pa-5 darktext--text">
                <v-row>
                  <v-col cols="12" class="py-0">
                    <p class="d-inline-block float-right">
                      <v-chip
                        class="
                          d-flex
                          text-small text-uppercase
                          font-weight-bold
                        "
                        label
                        color="anchor20opacity"
                        text-color="accent"
                        >{{ $t("custom") }}
                      </v-chip>
                    </p>
                    <p class="text-h5 font-weight-bold d-inline-block mr-3">
                      {{ $t("planBusiness") }}
                    </p>
                  </v-col>
                  <v-col cols="12" md="12" align="left" class="mt-n4 pt-0">
                    <span class="d-block text-body-2 greytext--text">{{
                      $t("textBusinessPlan")
                    }}</span>
                  </v-col>
                </v-row>
                <v-row :style="mobile() ? '' : 'height:100px'">
                  <v-col cols="12" md="4" align="center">
                    <span class="d-block text-h5 text-uppercase mb-1">SSO</span>
                    <span class="d-block text-body-2 greytext--text">{{
                      $t("businessPlanSSO")
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="4" align="center">
                    <span class="d-block text-h5 mb-1"
                      ><v-icon large class="darktext--text"
                        >mdi-phone-in-talk</v-icon
                      ></span
                    >
                    <span class="d-block text-body-2 greytext--text">{{
                      $t("businessPlanSupport")
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="4" align="center">
                    <span class="d-block text-h5 mb-1"
                      ><v-icon large class="darktext--text"
                        >mdi-monitor-account</v-icon
                      ></span
                    >
                    <span class="d-block text-body-2 greytext--text">{{
                      $t("businessPlanIntegration")
                    }}</span>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions
                class="pa-0 justify-center upgrade-card-action"
                data-testid="business-plus"
                @click.stop="contactUs"
                :style="{ cursor: 'pointer' }"
              >
              <span class="text-h6">{{ $t("contactUs") }}</span>
              </v-card-actions>
            </v-card>
            <v-row no-gutters v-if="productPlan.attributes.name != 'Business+'">
              <v-col cols="12" md="12" class="">
                <p class="text-body-2 no-break py-10 text-center">
                  <a
                    target="_blank"
                    href="https://skillboost.io/pricing-page/"
                    style="color: #263238"
                  >
                    {{ $t("compareAllPlans") }}
                  </a>
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <ConfirmationDialogUpgradePlan
      v-if="dialogVisibleUpgradePlan"
      ref="confirmationDialogUpgradePlan"
      :visible="dialogVisibleUpgradePlan"
      :cd-title="confirmationDialogTitle"
      :plan="upgradeToPlan"
      data-testid="confirmation-dialog-upgrade-plan"
      @close="dialogVisibleUpgradePlan = false"
      @proceedError="showErrorMessageUpgradePlan"
    />
  </nav>
</template>
<script>
import i18n from "../../plugins/i18n";
import AlertMessages from "../../components/AlertMessages";
import {
  getProPlan,
  getSpaceUsersStatistics,
  getRecalculatedStorage,
  getStripePortal
} from "../../api/spaceApi";
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";
import moment from "moment";
import ConfirmationDialogUpgradePlan from "../../components/ConfirmationDialogUpgradePlan.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    AlertMessages,
    ConfirmationDialogUpgradePlan,
  },
  mixins: [repeatedMethodsMixin],

  data() {
    return {
      valid: true,
      alertType: "",
      alertMsg: "",
      alertValue: false,
      spaceId: window.$cookies.get("space_id"),
      space: window.location.host.split('.')[0],
      loadingData: false,
      proName: "",
      storage: 0,
      proStorage: 0,
      proBoosters: 0,
      proSpaceAdmins: 0,
      proSpaceMembers: 0,
      proGuests: 0,
      statistics: {},
      leftBoosters: 0,
      leftSpaceMembers: 0,
      leftStorage: 0,
      usedStorage: 0,
      usedStorageProgress: 0,
      boosters_allowed: 0,
      space_members_allowed: 0,
      statisticsBoosters: 0,
      statisticsSpaceMembers: 0,
      trialEnds: localStorage.space
        ? JSON.parse(localStorage.space).trial_ends_at
        : null,
      loadingRecalculate: false,
      dialogVisibleUpgradePlan: false,
      upgradeToPlan: "",
      storageMB: 0,
      subscriptionEnds: localStorage.space? JSON.parse(localStorage.space).subscription_ends_at: '',
    };
  },
  computed: {
    ...mapGetters(["productPlan"]),

    trialExpirationDays() {
      let date_1 = new Date(this.productPlan.trial_ends_at);
      let date_2 = new Date();

      let difference = date_1.getTime() - date_2.getTime();
      let totalDays = Math.ceil(difference / (1000 * 3600 * 24));

      return totalDays;
    },
  },
  watch: {
    productPlan: {
      immediate: true,
      handler(to) {
        if (to) {
          //handle your changes
          this.showSubscription();
        }
      },
    },
  },
  async created() {
    window.scrollTo(0,0)
    if (this.$route.query.session_id && this.$route.query.session_id != "") {
      this.alertType = "success";
      this.alertMsg = i18n.t("upgradeToProSuccess");
      this.alertValue = true;
    }
    this.loadingData = true;
    this.getSubscriptionProPlan();
    this.getSubscriptionStatistics();
    this.loadingData = false;
  },
  methods: {
    confirmDeleteSpace() {
      this.$router.push({ path: "/space/delete" });
    },
    contactUs(){
      window.open("https://skillboost.io/contact", '_blank') ;
    },
    async showSubscription() {
      this.storage =
        this.productPlan.attributes != null
          ? this.productPlan.attributes.storage_gb
          : 0;
      this.storageMB = (this.storage * 1024).toFixed(3);
      let bytesValue = JSON.parse(localStorage.space).used_object_storage + JSON.parse(localStorage.space).used_local_storage;

      let usedStorageGB = bytesValue / (1024 * 1024 * 1024);
      //gb to mb
      this.usedStorage = (usedStorageGB * 1024).toFixed(3);
      this.leftStorage = (this.storageMB - this.usedStorage).toFixed(3);
      this.usedStorageProgress = Math.ceil((100 * this.usedStorage) / this.storageMB);
    },
    async getSubscriptionProPlan() {
      try {
        const response = await getProPlan(this.spaceId);
        if (response.status == 200) {
          this.proName = response.data.data.attributes.name;
          this.proStorage = response.data.data.attributes.storage_gb;
          this.proBoosters = response.data.data.attributes.boosters;
          this.proSpaceMembers = response.data.data.attributes.space_members;
          this.proSpace_admins = response.data.data.attributes.space_admins;
        }
      } catch (e) {
        if (e.response) {
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
          this.alertValue = true;
        }
      }
    },
    async getSubscriptionStatistics() {
      try {
        const response = await getSpaceUsersStatistics(this.spaceId);
        if (response.status == 200) {
          this.statistics = response.data.meta;
          this.statisticsBoosters = this.statistics.booster_count + this.statistics.booster_invites + this.statistics.admin_invites;
          this.statisticsSpaceMembers = this.statistics.total_members_count + this.statistics.total_invites;
          this.boosters_allowed = this.statistics.boosters_allowed;
          this.space_members_allowed = this.statistics.space_members_allowed;
          this.leftBoosters = this.statistics.boosters_allowed - this.statisticsBoosters;
          this.leftSpaceMembers = this.statistics.total_allowed - this.statisticsSpaceMembers;
        }
      } catch (e) {
        if (e.response) {
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
          this.alertValue = true;
        }
      }
    },
    async recalculateStorage() {
      this.loadingRecalculate = true;
      try {
        const response = await getRecalculatedStorage(this.spaceId);
        if (response.status == 200) {
          this.alertType = "success";
          this.alertMsg = i18n.t("storageWillBeUpdated");
          this.alertValue = true;
        }
      } catch (e) {
        if (e.response) {
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
          this.alertValue = true;
        }
      }
      this.loadingRecalculate = false;
    },

    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD MMM YYYY");
      }
    },

    showErrorMessageUpgradePlan() {
      this.dialogVisibleUpgradePlan = false;
      this.alertType = "error";
      this.alertMsg = i18n.t("serverError");
      this.alertValue = true;
    },
     async getStripePortal() {
        try {
          const response = await getStripePortal(this.spaceId);
          if (response.status) {
            if (response.status == 200) {
              window.location.href = response.data.meta.stripe_portal_url
            }
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status == 403) {
              this.$router.push({ name: "PageAccessDenied" });
            } else {
              this.$emit('proceedError')
            }
          }
        }
      
     },
      

  },
};
</script>